import { ArrowRight } from "lucide-react";

const PROJECTS = [
  {
    title: "Commercial Office Buildout",
    tag: "Demo to Buildout",
    img: "https://images.unsplash.com/photo-1579487785973-74d2ca7abdd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwaW50ZXJpb3IlMjBidWlsZG91dHxlbnwwfHx8fDE3ODQxODI1MDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Rooftop HVAC & Roofing",
    tag: "HVAC · Roofing",
    img: "https://images.unsplash.com/photo-1705579605238-24a90c8799c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwcm9vZmluZyUyMHJvb2Z0b3AlMjBodmFjJTIwdW5pdHN8ZW58MHx8fHwxNzg0MTgyNTA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "High & Low Voltage Wiring",
    tag: "Electrical",
    img: "https://images.unsplash.com/photo-1635335874521-7987db781153?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMGNvbW1lcmNpYWwlMjBlbGVjdHJpY2FsJTIwcGFuZWwlMjB3aXJpbmd8ZW58MHx8fHwxNzg0MTgyNTA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Interior Paint & Finishes",
    tag: "Painting · Drywall",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxmcmVzaGx5JTIwcGFpbnRlZCUyMG1vZGVybiUyMGNvbW1lcmNpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQxODI1MDV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Full Interior Remodel",
    tag: "Buildout · Tile · Ceilings",
    img: "https://images.unsplash.com/photo-1718816281270-ed6ef8357859?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwaW50ZXJpb3IlMjBidWlsZG91dHxlbnwwfHx8fDE3ODQxODI1MDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Rooftop Equipment Service",
    tag: "Commercial Equipment",
    img: "https://images.unsplash.com/photo-1737256359080-9354dbcc21ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwcm9vZmluZyUyMHJvb2Z0b3AlMjBodmFjJTIwdW5pdHN8ZW58MHx8fHwxNzg0MTgyNTA2fDA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Projects() {
  return (
    <section id="projects" className="py-20 lg:py-28" data-testid="projects-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">Recent Projects</p>
            <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight text-slate-900">
              The Quality is in the Details
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              A look at recent commercial work across our trades — from full buildouts to rooftop systems.
            </p>
          </div>
          <a href="#book" data-testid="projects-book-cta" className="inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all whitespace-nowrap">
            Start Your Project <ArrowRight className="h-5 w-5" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p) => (
            <div
              key={p.title}
              data-testid={`project-card-${p.title.toLowerCase().replace(/\s|&|·/g, "-")}`}
              className="group relative rounded-xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block text-[11px] uppercase tracking-wider font-semibold text-white/80 bg-accent/90 px-2.5 py-1 rounded mb-2">
                  {p.tag}
                </span>
                <h3 className="font-display font-semibold text-lg text-white">{p.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
